'use client';

import type { CSSProperties, ReactElement } from 'react';
import {
  CmarkdownvisualError,
  CmarkdownvisualErrorReason,
  CmarkdownvisualType,
} from '../Cmarkdownvisual';
import { CmarkdownmindmapFlowView } from './CmarkdownmindmapFlowView';
import { MindmapRenderKind } from './mindmap-render-model';
import { useCmarkdownmindmapController } from './useCmarkdownmindmapController';
import type { DataElScope } from '@/utils/dataEl';

export interface CmarkdownmindmapProps {
  dataElScope: DataElScope;
  content: string;
  className?: string;
  style?: CSSProperties;
}

export function Cmarkdownmindmap({
  dataElScope,
  content,
  className,
  style,
}: CmarkdownmindmapProps): ReactElement {
  const controller = useCmarkdownmindmapController({ content, dataElScope });
  const parsedModel = controller.parsedModel;
  const renderModel = controller.renderModel;

  if (renderModel.kind === MindmapRenderKind.Empty) {
    return (
      <CmarkdownvisualError
        dataElScope={dataElScope}
        type={CmarkdownvisualType.Mindmap}
        reason={
          parsedModel.parsed
            ? CmarkdownvisualErrorReason.Empty
            : CmarkdownvisualErrorReason.Unparseable
        }
      />
    );
  }

  return (
    <CmarkdownmindmapFlowView
      className={className}
      controller={controller}
      dataElScope={dataElScope}
      parsedModel={parsedModel}
      renderModel={renderModel}
      style={style}
    />
  );
}
